import { createContext } from 'react';

import { OrderEntity } from 'api/types/entity';

export interface OrderContextProps {
  order: OrderEntity;
  onChangeStatus: () => void;
  onDelete: () => void;
  onEnableEdit: (onCallback: () => void) => void;
  onDisableEdit: (onCallback: () => void) => void;
  onDownloadOrder?: () => void;
}

export const OrderContext = createContext<OrderContextProps | null>(null);
